document.addEventListener('DOMContentLoaded', function() {
  // Handle FAQ accordion
  const faqQuestions = document.querySelectorAll('.faq-accordion-question');
  
  faqQuestions.forEach(question => {
    question.addEventListener('click', () => {
      const isExpanded = question.getAttribute('aria-expanded') === 'true';
      question.setAttribute('aria-expanded', !isExpanded);
      
      const answer = question.nextElementSibling;
      if (isExpanded) {
        answer.hidden = true;
      } else {
        answer.hidden = false;
      }
    });
  });
}); 